import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { SIZES } from '../../../../styles/theme'

export const StyledListItem = styled(Link)`
  background-color: rgba(45, 44, 60, 1);
  border-radius: 23px;
  display: grid;
  align-items: center;
  grid-template-columns: 100px 1fr 50px;
  grid-gap: 25px;
  padding: 20px 25px;
  margin: 20px;
  cursor: pointer;
  text-decoration: none !important;


  /* To prevent overlapping with right navbar
     While setting padding-righ to parent container works,
     that causes the scrollbar to not stick to the page edge
   */
  width: calc(100% - 110px);

  ${SIZES.mobile} {
    width: auto;
    border-radius: 18px;
    grid-template-columns: 50px 1fr;
    grid-gap: 12px;
    padding: 15px 20px;
    margin: 10px;
    .listAction {
      display: none;
    }
    .listContent {
      font-size: 0.8em;
    }
  }

  &:hover {
    background-color: rgba(45, 44, 60, 0.8);
    .listAction img {
      transform: scale(1.1);
    }
  }

  .listThumbnail {
    img {
      width: 100%;
    }
  }

  .listContent {
    .title {
      font-weight: bold;
      color: white;
      text-transform: uppercase;
    }

    .subtitle {
      color: #9395a5;
      text-transform: capitalize;
    }
  }

  .listAction {
    img {
      width: 100%;
      transition: 150ms ease-in;
    }
  }
`
